import React, { useState, useRef, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import permissions from '../../../permissionsList';
import AccessControl from '../../../AccessControl';
import { deleteCategory, deleteFile, fetchFileRequest } from "../../../redux/actions/docCategoryAction";
import { DragDropContext, Droppable,Draggable } from '@hello-pangea/dnd';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronRight, File, Plus, Pencil, Trash2 } from 'lucide-react';
import './Category.css';
import  AddCategory  from './/AddCategory';
import FilePreview from "./FilePreview.js";
import DocumentIcon from "../../../assets/svgImages/DocumentIcon.svg";
import AddSubCategory from '../../../assets/svgImages/AddPlusIcon.svg'
import DeleteConfirmation from "./DeleteConfirmation.js";
import { GitCompareArrows } from 'lucide-react';
import { formMediaFullUrl } from '../../../utilities/imageUtilities';







const moveItem = (items, id, type = "categories") => {
  if (!items) return null;
  
  for (let i = 0; i < items.length; i++) {
    if (items[i].id == id && type === "files" && items[i].isFile) {
      return items.splice(i, 1)[0];
    }
    
    if (items[i].id == id && type === "categories" && !items[i].isFile) {
      return items.splice(i, 1)[0];
    }
    
    if (items[i].categories?.length > 0) {
      const item = moveItem(items[i].categories, id, type);
      if (item) return item;
    }
    
    if (type === "files" && items[i].files?.length > 0) {
      const item = moveItem(items[i].files, id, type);
      if (item) return item;
    }
  }
  return null;
};

const insertItem = (items, parentId, item, index, type = 'categories') => {
  if (!parentId) {
    items.splice(index, 0, item);
    return true;
  }
  for (const currentItem of items) {
    if (currentItem.id == parentId) {
      currentItem[type] = currentItem[type] || [];
      currentItem[type].splice(index, 0, item);
      return true;
    }

    if (currentItem.categories?.length > 0) {
      const insertedInCategories = insertItem(currentItem.categories, parentId, item, index, type);
      if (insertedInCategories) return true;
    }

    if (type === "files" && currentItem.files?.length > 0) {
      const insertedInFiles = insertItem(currentItem.files, parentId, item, index, type);
      if (insertedInFiles) return true;
    }
  }
  return false;
};

// Row Component
const Row = ({ item, level = 0, index, id, draggable = false, type, onShowAddSubcategoryPopup, onShowAddFilePopup, showIntegrationColumn, catmoParentId, isCatmoDescendant = false, isCategoryExpanded, toggleCategoryExpansion  }) => {
  // console.log ('cat table id', id)

  const dispatch = useDispatch();
  const ref = useRef();
  // const [isOpen, setIsOpen] = useState(item.isOpen || false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePreview, setIsFilePreview] = useState(null);
  const reduxSelectedFile = useSelector(state => state.docCategoryReducer.selectedFile);
  const [toggle, setToggle] = useState([]);
  const categoriesList = useSelector(state => state.docCategoryReducer.categoriesFiles);
  const [showEditFilePopup, setShowEditFilePopup] = useState(false);
  const [showEditCategoryPopup, setShowEditCategoryPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [editModalData, setEditModalData] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isChild, setIsChild] = useState(false);
  const isFileItem = item.isFile === true; 
  const hasFiles = Array.isArray(item.files);
  const isOpen = isCategoryExpanded ? isCategoryExpanded(item.id) : false;
  

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };


  const handleAddSubcategory = () => {
    
    const newSubcategoryData = {
      parentId: item.id,  
      parent: item.id,    
      isNew: true,
       parentCategory: item         
    };
    
    setIsChild(true);
    onShowAddSubcategoryPopup(newSubcategoryData); 
  };

  // Function to show edit popup
  const showEditAction = (data, isFile = false) => {
    // console.log ("Data in editAction", data)
    setToggle(categoriesList.categories);
    isFile ? setShowEditFilePopup(true) : setShowEditCategoryPopup(true);
    setShowPopup(true);
    // A row nested below the top level is a subcategory, so the edit modal must
    // show the "Nested under" parent dropdown (used to move the category).
    setIsChild(!isFile && level > 0);
    // Stamp the row's resolved lineage onto the modal data. The row already knows
    // it is a Catmo descendant (via isCatmoDescendant handed down by its parent),
    // but nested items/files may not carry the flag on themselves.
    setEditModalData({
      ...data,
      hasCatmoLineage: data.hasCatmoLineage === true || hasCatmoLineage
    });
  };
 
   // Close the edit popup
   const handleCloseEditPopup = () => {
    setShowEditCategoryPopup(false);
    setShowEditFilePopup(false);
    setShowPopup(false);
  };

  const showDeleteAction = (data) => {
    setItemToDelete(data);
    setToggle(categoriesList.categories);
    let type = data.isFile ? "file" : "category";
    let message = data?.categories?.length > 0 || data?.files?.length > 0 ? `Deleting this category : ${data.name} will also delete all its files and subcategories`: `Are you sure you want to delete ${type} : ${data.name} ?`;
		
    setDeleteMessage(message);
    setShowDeleteConfirmation(true);
	};

   // Function to handle deletion confirmation through DeleteConfirmation.js
   const handleConfirmDelete = () => {
    if (!itemToDelete) {
      setShowDeleteConfirmation(false);
      return;
    }
    
    
    const setStateFunc = (response) => {
      // Close the confirmation dialog
      setShowDeleteConfirmation(false);
      setItemToDelete(null);
      if (response.success) {

        
      } else {
        console.error("Error deletion:", response.error);
        
      }
    };
    
    // Dispatch the appropriate action based on item type
    if (itemToDelete.isFile) {
      dispatch(deleteFile({
        id: itemToDelete.id, 
        parentId: itemToDelete.parentCategoryId || itemToDelete.parent, 
        setStateFunc
      }));
    } else {

      
      dispatch(deleteCategory({
        id: itemToDelete.id,
        setStateFunc}));
    }
  };
  
  // Function to cancel deletion
  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
    setItemToDelete(null);
  };

  // useEffect(() => {
  //   setIsOpen(item.isOpen || false);
  // }, [item.isOpen]);

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (isPopupVisible && ref.current && !ref.current.contains(e.target)) {
        setIsPopupVisible(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isPopupVisible]);

  // const toggleChildren = () => {
  //   const newIsOpen = !isOpen;
  //   // console.log(`Toggling category ${item.name} (ID: ${item.id}) - isOpen: ${isOpen} -> ${newIsOpen}`);
  //   setIsOpen(!isOpen);
  //   item.isOpen = !isOpen;
  // };

  const toggleChildren = () => {
  if (toggleCategoryExpansion) {
    toggleCategoryExpansion(item.id);
  }
};

  const handleAddNewFile = () => {
    const fileData = {
    parentId: item.id,
    parent: item.id,
    parentCategory: item, 
    defaultCategory: item 
  };
  
  onShowAddFilePopup(fileData);
    // console.log("Adding new file to category:", item.id);
  };

  const handleFileClick = (file) => {
  console.log("File clicked:", file);
  console.log("File has catmo lineage:", file.hasCatmoLineage);
  
  const existingUrl = file.file || file.fileUrl || file.url;
  
  if (existingUrl) {
    proceedWithPreview(file, existingUrl);
  } else if (file.object_id) {
    
    dispatch(fetchFileRequest({
      fileId: file.id,
      callback: (fetchedFileData) => {
        
        // For Catmo files, check different possible URL properties
        let fileUrl = fetchedFileData.file || fetchedFileData.url;
        
        // If it's a Catmo file and no standard URL, check for other properties
        if (!fileUrl && (file.hasCatmoLineage || file.catmo_id || fetchedFileData.catmo_id)) {
          fileUrl = fetchedFileData.catmo_url || 
                   fetchedFileData.media_url || 
                   fetchedFileData.download_url ||
                   fetchedFileData.fileUrl ||
                   (fetchedFileData.object_id ? `/api/catmo/media/${fetchedFileData.object_id}` : null);
        }
        
        if (fileUrl) {
          proceedWithPreview(fetchedFileData, fileUrl);
        } else {
          alert(`Cannot preview "${file.name}" - file not available.`);
        }
      }
    }));
  } else {
    alert(`Cannot preview "${file.name}" - file not available.`);
  }
};

// Helper function to handle the actual preview
const proceedWithPreview = (fileData, fileUrl) => {
  const fullFileUrl = formMediaFullUrl(fileUrl);
  const fileForPreview = {
    id: fileData.id,
    name: fileData.name,
    type: determineFileType(fullFileUrl, fileData.name, fileData.mime_content_type || fileData.mimeType || fileData.mimetype),
    file: fullFileUrl,
    mimeType: fileData.mime_content_type || fileData.mimeType || fileData.mimetype,
    object_id: fileData.object_id
  };
  
 
  setSelectedFile(fileForPreview);
  setIsFilePreview(true);
};
  
  // Helper function to determine file type
  const determineFileType = (fileUrl, fileName, mimeType = null) => {

    if (mimeType && mimeType !== 'application/octet-stream') {
    return mimeType;
    }

    // Extract file extension from name
    const extension = fileName.split('.').pop().toLowerCase();
    
    // Check extension for known types that FilePreview supports
    if (extension === 'pdf') {
      return 'application/pdf';
    } else if (['jpg', 'jpeg', 'png'].includes(extension)) {
      return extension === 'png' ? 'image/png' : 'image/jpeg';
    }
    
    
    if (fileUrl.includes('.pdf')) {
      return 'application/pdf';
    } else if (fileUrl.includes('.jpg') || fileUrl.includes('.jpeg')) {
      return 'image/jpeg';
    } else if (fileUrl.includes('.png')) {
      return 'image/png';
    }
    
    // Default fallback
    return 'application/octet-stream';
  }

  
  const closeFilePreview = () => {
    setSelectedFile(null);
    setIsFilePreview(false);
  };

  const hasCatmoLineage = useMemo(() => {
    // Check if this is the catmo node itself
    const isCatmo = item && item.name && item.name.toLowerCase() === 'catmo';
    
    // Check if this item has the hasCatmoLineage flag (for uncategorized files from Catmo)
    const hasLineageFlag = item && item.hasCatmoLineage === true;
    
    // Check if this is a direct child of the catmo node
    const isDirectCatmoChild = catmoParentId && (
      // Check both parent and parentId fields for flexibility
      (item.parent && (Number(item.parent) === Number(catmoParentId) || 
                      (typeof item.parent === 'object' && item.parent.id === catmoParentId))) || 
      (item.parentId && Number(item.parentId) === Number(catmoParentId)) ||
      // Also check parentCategoryId which is sometimes used
      (item.parentCategoryId && Number(item.parentCategoryId) === Number(catmoParentId))
    );
                             
    // Check if this was marked as a descendant by a parent row
    const isDescendant = isCatmoDescendant;
    
    const result = isCatmo || hasLineageFlag || isDirectCatmoChild || isDescendant;
    
    if (result) {
      // console.log(`Item ${item.name} (ID: ${item.id}) has catmo lineage: 
      //   isCatmo=${isCatmo}, 
      //   hasLineageFlag=${hasLineageFlag},
      //   isDirectCatmoChild=${isDirectCatmoChild}, 
      //   isDescendant=${isDescendant}`);
    }
    
    return result;
  }, [item, catmoParentId, isCatmoDescendant]);

    const isFileAvailable = (file) => {
    // Check for direct URLs first
    if (file.file || file.fileUrl || file.url) {
      return true;
    }
    
    // Check if we can construct URL from object_id
    if (file.object_id) {
      return true;
    }
    
    return false;
  };

  
  // console.log(`Category: ${item.name}, ID: ${id}, isFile: ${item.isFile}, files:`, item.files);

  return (
    <>
    <div
      className="row"
      style={{ paddingLeft: `${level * 12}px` }}  
    >
      <div className="row-documents">
        <div className="cell menu-category" title={hasCatmoLineage ? "This category is managed by Catie Mobile, can only assign a alert device" : ""}>
          <button 
            onClick={isFileItem ? (e) => handleFileClick(item) : toggleChildren} 
            className={isFileItem ? "file-button" : "toggle-button"}
          >
            {isFileItem ? (
              <File size={16} />
            ) : (
              isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />
            )}
          </button>
          <span>{item.name}</span>
          {/* {console.log("Item debug:", {
            name: item.name,
            isFileItem: isFileItem,
            itemIsFile: item.isFile,
            docType: item.doc_type,
            hasCategories: !!item.categories,
            hasFiles: !!item.files
          })} */}
          {isFileItem && item.isFile === true && !isFileAvailable(item) && <span className="file-unavailable">(Unavailable)</span>}
          {!hasCatmoLineage && !isFileItem && (
          <AccessControl
          feature={permissions.static.DocAndImages.addCategoryFile}
          permissionMessage={false}>
          <button title="Add sub category" onClick={handleAddSubcategory}><img alt="addSubCat" className="add-sub-category"src={AddSubCategory} ></img></button>
          </AccessControl>
          )}
        </div>
        {showIntegrationColumn && (
          <div className="cell integration">
          <div className="integration-content">
            {hasCatmoLineage ? (
              <GitCompareArrows size={16} title="Catmo Integration" />
            ) : '-'}
          </div>
        </div>
      )}
        <div className="cell last-updated">
        {item.modified  
          ? `${new Date(item.modified).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })}. ${new Date(item.modified).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
          })}`
        : '-'}
        </div>
        <div className="cell created-by">
          {item.createdBy || '-'}
        </div>
        <div className="cell manage" ref={ref}>
        
            <>
              {/* Show edit button for users with full edit permissions */}
              <AccessControl
                feature={permissions.static.DocAndImages.editDeleteCatOrFile}
                permissionMessage={false}>
                <button title="Edit" onClick={(e) => {
                  // console.log("Edit button clicked for:", item);
                  showEditAction(item, item.isFile || false);
                }}>
                  <Pencil size={10} />
                </button>
              </AccessControl>
              
              {/* Show edit button for users with only associate permission (who don't have full edit) */}
              <AccessControl
                feature={permissions.static.DocAndImages.associateDevices}
                permissionMessage={false}>
                <button title="Edit (Associate Devices Only)" onClick={(e) => {
                  // console.log("Edit button clicked for associate only:", item);
                  showEditAction(item, item.isFile || false);
                }}>
                  <Pencil size={10} />
                </button>
              </AccessControl>
              {!hasCatmoLineage && (
              <AccessControl
                feature={permissions.static.DocAndImages.editDeleteCatOrFile}
                permissionMessage={false}>
                <button title="Delete" onClick={(e) => {
                  // console.log("Delete button clicked for:", item);
                  showDeleteAction(item);
                }}>
                  <Trash2 size={10} />
                </button>
              </AccessControl>
              )}
            </>
          
        </div>
      </div>

      {/* This is the expanded content section - only for categories */}
      {isOpen && !isFileItem && (
        <div className="children">
          {/* {console.log("Files in child:", item.files)} */}
          {/* Add New File button */}
          {!hasCatmoLineage && (
          <div className="file-options" style={{ paddingLeft: `${(level + 1) * 20}px` }}>
            <button onClick={handleAddNewFile} className="add-file-btn">
            <img alt="uploadFiles" src={DocumentIcon} ></img>
              <Plus size={16} /> Add New File
            </button>
          </div>
          )}
          
          {/* Display files in this category */}
          {hasFiles ? (
              item.files.map((file, index) => (
            <div 
              key={`file-${file.id || index}`} 
              className="row-documents file-item"
              // style={{ paddingLeft: `${(level + 1) * 20}px` }}
              onClick={(e) => {
                e.stopPropagation(); 
                handleFileClick(file);
              }}
            >
              <div className="cell menu-category">
                <File size={16} />
                <span>{file.name}</span>
                {!isFileAvailable(file) && <span className="file-unavailable">(Unavailable)</span>}
              </div>
              {/* {showIntegrationColumn && (
                <div className="cell integration">
                  {hasCatmoLineage ? (
                    <GitCompareArrows size={16} title="Catmo Integration" />
                  ) : '-'}
                </div>
              )} */}
              <div className="cell last-updated">
              {item.modified  
                ? `${new Date(item.modified).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}. ${new Date(item.modified).toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}`
              : '-'}
              </div>
              <div className="cell created-by">
                {file.createdBy || '-'}
              </div>
              <div className="cell manage">
                {/* Show edit button for users with full edit permissions */}
                <AccessControl
                  feature={permissions.static.DocAndImages.editDeleteCatOrFile}
                  permissionMessage={false}>
                  <button title="Edit" onClick={(e) => {
                    e.stopPropagation(); 
                    // console.log("Edit button clicked for file:", file);
                    const fileWithParent = {
                      ...file,
                      parentCategoryId: item.id // item is the parent category
                    };
                    showEditAction(fileWithParent, true); 
                  }}>
                    <Pencil size={10} />
                  </button>
                </AccessControl>
                
                {/* Show edit button for users with only associate permission */}
                <AccessControl
                  feature={permissions.static.DocAndImages.associateDevices}
                  permissionMessage={false}>
                  <button title="Edit (Associate Devices Only)" onClick={(e) => {
                    e.stopPropagation(); 
                    // console.log("Edit button clicked for file:", file);
                    const fileWithParent = {
                      ...file,
                      parentCategoryId: item.id // item is the parent category
                    };
                    showEditAction(fileWithParent, true); 
                  }}>
                    <Pencil size={10} />
                  </button>
                </AccessControl>
                {!hasCatmoLineage && (
                <AccessControl
                  feature={permissions.static.DocAndImages.editDeleteCatOrFile}
                  permissionMessage={false}>
                  <button title="Delete" onClick={(e) => {
                    e.stopPropagation(); 
                    // console.log("Delete button clicked for file:", file);
                    const fileWithParent = {
                      ...file,
                      parentCategoryId: item.id, // item is the parent category
                      isFile: true
                    };
                    showDeleteAction(fileWithParent); 
                  }}>
                    <Trash2 size={10} />
                  </button>
                </AccessControl>
                )}
              </div>
            </div>
          ))
        // ) : isOpen && !item.isFile ? (
        //   <div style={{ paddingLeft: `${(level + 1) * 20}px` }}>
        //     No files in this category
        //   </div>
        ) : null}
          
          {/* Subcategories section */}
          {item.categories && item.categories.length > 0 && (
            <div className="subcategories">
              {item.categories.map((subItem, i) => (
                <Row
                  key={subItem.id}
                  item={subItem}
                  level={level + 1}
                  index={i}
                  id={subItem.id}
                  draggable={false}
                  type="categories"
                  onShowAddFilePopup={onShowAddFilePopup}
                  onShowAddSubcategoryPopup={onShowAddSubcategoryPopup}
                  catmoParentId={catmoParentId}  // Pass down the catmoParentId
                  // showIntegrationColumn={showIntegrationColumn}
                  isCatmoDescendant={hasCatmoLineage}
                  isCategoryExpanded={isCategoryExpanded}
                  toggleCategoryExpansion={toggleCategoryExpansion}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>

    {showEditCategoryPopup && showPopup && (
      <AddCategory
        data={editModalData}
        mode="CATEGORY"
        isChild={isChild}
        isEditing={true} 
        onCancel={handleCloseEditPopup}
        onClose={handleCloseEditPopup}
      />
    )}

    {showEditFilePopup && showPopup && (
      <AddCategory
        data={editModalData}
        mode="FILE"
        isChild={false}
        isEditing={true} 
        onCancel={handleCloseEditPopup}
        onClose={handleCloseEditPopup}
      />
    )}

    {(selectedFile && isFilePreview) && (
      <FilePreview 
        data={selectedFile} 
        onCancel={closeFilePreview} 
      />
    )}

    {showDeleteConfirmation && (
      <DeleteConfirmation
        message={deleteMessage}
        onCancel={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    )}
  </>
);
};
Row.propTypes = {
  item: PropTypes.shape({
    categories: PropTypes.array,
    uncategorizedFiles: PropTypes.array,
    name: PropTypes.string,
    mimetype: PropTypes.string,
    label: PropTypes.string,
    files: PropTypes.array,
    createdBy: PropTypes.string,
    updatedAt: PropTypes.string,
    isOpen:PropTypes.bool,
    id:PropTypes.number,
    mediaId:PropTypes.string,
    isInherited:PropTypes.bool,
    onShowAddSubcategoryPopup: PropTypes.func,
    onShowAddFilePopup: PropTypes.func
  }),
  level: PropTypes.number,
  index:PropTypes.number,
  id:PropTypes.number,
  draggable:PropTypes.bool,
  onShowAddFilePopup: PropTypes.func,
  onShowAddSubcategoryPopup: PropTypes.func,
  catmoParentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showIntegrationColumn: PropTypes.bool,
  isCatmoDescendant: PropTypes.bool
};

// Main CategoryTable Component
const CategoryTable = ({ currentItems, draggable = false, showAddFilePopup, showAddCategoryPopup, isCategory, handlePopupClose: parentHandlePopupClose, searchTerm = ''  }) => {
  const dispatch = useDispatch();
  const [initialData, setInitialData] = useState(currentItems || { categories: [], uncategorizedFiles: [] });
  const [showAddSubcategoryPopup, setShowAddSubcategoryPopup] = useState(false);
  const [showLocalFilePopup, setShowLocalFilePopup] = useState(false);
  const [subcategoryParentData, setSubcategoryParentData] = useState({});
  const [catmoParentId, setCatmoParentId] = useState(null);
  const [showIntegrationColumn, setShowIntegrationColumn] = useState(false);
  const catmoNodeId = useSelector(state => state.docCategoryReducer.catmoNodeId);
  const categoriesFiles = useSelector(state => state.docCategoryReducer.categoriesFiles);
  const deletedCategoryIds = categoriesFiles?.deletedCategoryIds || [];
  const [expandedCategories, setExpandedCategories] = useState(new Set());
  

  console.log("my intialdata", initialData);
  // console.log("Redux categoriesFiles:", categoriesFiles);
  // console.log("Redux uncategorizedFiles:", categoriesFiles?.uncategorizedFiles);
  // console.log("deletedCategoryIds from Redux:", deletedCategoryIds);


  // Filter out deleted categories from the initialData
  const filteredData = useMemo(() => {
    if (!initialData) return { categories: [], uncategorizedFiles: [] };
    
    // Function to filter categories recursively
    const filterDeletedCategories = (categories) => {
      if (!categories || !Array.isArray(categories)) return [];
      
      return categories
        .filter(category => category && !deletedCategoryIds.includes(category.id))
        .map(category => {
          if (!category) return null;
          return {
            ...category,
            categories: category.categories ? filterDeletedCategories(category.categories) : []
          };
        })
        .filter(Boolean); // Remove any nulls
    };
    
    return {
      uncategorizedFiles: initialData.uncategorizedFiles || [],
      categories: filterDeletedCategories(initialData.categories || []),
      categoriesFiles: initialData.categoriesFiles || []
    };
  }, [initialData, deletedCategoryIds]);

  useEffect(() => {
  console.log("Redux state updated:", {
    categoriesCount: filteredData?.categories?.length,
    uncategorizedCount: filteredData?.uncategorizedFiles?.length,
    firstCategory: filteredData?.categories?.[0]?.name,
    firstCategoryFiles: filteredData?.categories?.[0]?.files?.length
  });
}, [filteredData]);
  
  useEffect(() => {
  if (searchTerm && searchTerm.trim() !== '' && filteredData.categories) {
    // Helper function to find categories to expand based on a search term
    const findCategoriesToExpand = (categories, searchTerm) => {
      const expandedSet = new Set();
      
      const searchCategories = (categories, parentIds = []) => {
        for (const category of categories) {
          if (!category) continue;
          
          const categoryMatches = category.name && category.name.toLowerCase().includes(searchTerm.toLowerCase());
          
          // Check if any files in this category match
          const hasMatchingFiles = category.files && category.files.some(file => 
            file && file.name && file.name.toLowerCase().includes(searchTerm.toLowerCase())
          );
          
          // Check subcategories recursively
          let hasMatchingSubcategories = false;
          if (category.categories && category.categories.length > 0) {
            hasMatchingSubcategories = searchCategories(category.categories, [...parentIds, category.id]);
          }
          
          // If this category or its children have matches, expand it and all parents
          if (categoryMatches || hasMatchingFiles || hasMatchingSubcategories) {
            // Expand this category
            expandedSet.add(category.id);
            
            // Expand all parent categories
            parentIds.forEach(parentId => expandedSet.add(parentId));
          }
        }
        
        return expandedSet.size > 0;
      };
      
      searchCategories(categories);
      return expandedSet;
    };
    
    const categoriesToExpand = findCategoriesToExpand(filteredData.categories, searchTerm);
    setExpandedCategories(categoriesToExpand);
  }
}, [searchTerm, filteredData.categories]);

  const isCatmoNode = (node) => {
    return node && node.name && node.name.toLowerCase() === 'catmo';
  };
  
  const findCatmoNode = (data) =>{
    if (!data) return null;
    
    // Helper function to search recursively
    const searchForCatmo = (items) => {
      if (!items || !Array.isArray(items)) return null;
      
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        
        // Check if this is the Catmo node (case insensitive comparison)
        if (item.name && item.name.toLowerCase() === 'catmo') {

          return item;
        }
        
        // Recursively check subcategories
        if (item.categories && Array.isArray(item.categories)) {
          const found = searchForCatmo(item.categories);
          if (found) return found;
        }
      }
      
      return null;
    };
    
    // Start search from top-level categories
    if (data.categoriesFiles) {
       return searchForCatmo(data.categoriesFiles);
      
    }
    
    // If the data itself is an array, check directly
    if (Array.isArray(data)) {
      return searchForCatmo(data);
    }
    
    return null;
  };

  const isChildOfCatmo = (node) => {
    if (!node || !node.parent) return false;
  
    // Parent is object with name 'catmo'
    if (typeof node.parent === 'object' && node.parent.name && 
        node.parent.name.toLowerCase() === 'catmo') {
      // console.log(`${node.name} is child of Catmo (object parent)`);
      return true;
    }
    
    // Parent ID matches Catmo ID
    if (catmoParentId && (
      node.parent === catmoParentId || 
      (typeof node.parent === 'object' && node.parent.id === catmoParentId) ||
      node.parentId === catmoParentId ||
      node.parentCategoryId === catmoParentId
    )) {

      return true;
    }
    
    return false;
  };
  
 
  // Check for catmo node on initial data load
  useEffect(() => {
    // First try to use the value from Redux
    if (catmoNodeId) {

      setCatmoParentId(catmoNodeId);
      setShowIntegrationColumn(true);
      return;
    }
    
    // Fallback to finding it in the data if not in Redux
    if (currentItems) {
      // console.log("Checking for catmo node in current items:", currentItems);
      const catmoNode = findCatmoNode(currentItems);
      
      if (catmoNode) {
        console.log("Found catmo node with ID:", catmoNode.id);
        setCatmoParentId(catmoNode.id);
        setShowIntegrationColumn(true);
      } else {

        setCatmoParentId(null);
        setShowIntegrationColumn(false);
      }
    }
  }, [currentItems, catmoNodeId]);


  const hasCatmoCategories = useMemo(() => {
    return !!catmoNodeId || !!catmoParentId;
  }, [catmoNodeId, catmoParentId]);
    
  // Helper function to find a name in categories recursively
  function findCatNameRecursively(categories, nameToFind) {
    if (!categories || !Array.isArray(categories)) return false;
    
    for (const cat of categories) {
      // Check name
      if (cat.name && cat.name.toLowerCase().includes(nameToFind.toLowerCase())) {
        return true;
      }
      
      // Check children
      if (cat.children && cat.children.length > 0) {
        if (findCatNameRecursively(cat.children, nameToFind)) {
          return true;
        }
      }
      
      // Check categories
      if (cat.categories && cat.categories.length > 0) {
        if (findCatNameRecursively(cat.categories, nameToFind)) {
          return true;
        }
      }
    }
    
    return false;
  }

  useEffect(() => {
    // console.log("CategoryTable received currentItems:", currentItems);
    // console.log("CategoryTable currentItems uncategorizedFiles:", currentItems?.uncategorizedFiles);
    if (currentItems && JSON.stringify(currentItems) !== JSON.stringify(initialData)) {
      setInitialData(currentItems || { categories: [], uncategorizedFiles: [] });
    }
  }, [currentItems, initialData]);

  //If showAddFilePopup prop is a function, it calls that function with the categoryId
  const handleShowFilePopup = (categoryData) => {
    if (typeof showAddFilePopup === 'function') {
    showAddFilePopup(categoryData);
    }else {
      // Otherwise manage state locally
      setShowLocalFilePopup(true);
      setSubcategoryParentData(categoryData);
    }
  };

  // Helper function to check if category is expanded
  const isCategoryExpanded = (categoryId) => {
    return expandedCategories.has(categoryId);
  };

  // Helper function to toggle category expansion
  const toggleCategoryExpansion = (categoryId) => {
    setExpandedCategories(prev => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
  };

  const handleShowAddSubcategoryPopup = (parentData) => {
    // Set state to indicate adding a subcategory
    setShowAddSubcategoryPopup(true);
    setSubcategoryParentData(parentData);
  };

  // Handler for drag and drop of uncategorized files
  const onUncategorizedDragEnd = (result) => {
    // Handle drag and drop logic here if needed
  };

  // Local handler to close all popups
  const handlePopupClose = () => {
    // console.log("handlePopupClose called in CategoryTable");
    setShowAddSubcategoryPopup(false);
    setShowLocalFilePopup(false);
    setSubcategoryParentData({});
    
    // If parent component provided a handlePopupClose function, call it too
    if (typeof handlePopupClose === 'function') {
      parentHandlePopupClose();
    }
  };



  return (
    <div className="category-table">
      <div className="header">
        <div className="cell menu-category">Menu Category</div>
        {showIntegrationColumn && (
          <div className="cell integration">Integration</div>
        )}
        <div className="cell last-updated">Last Updated</div>
        <div className="cell created-by">Created By</div>
        <div className="cell manage">Manage</div>
      </div>


      {filteredData && (filteredData.uncategorizedFiles?.length > 0 || filteredData.categories?.length > 0) ? (  
      <>
      {filteredData?.uncategorizedFiles?.length > 0 && (
        <DragDropContext onDragEnd={onUncategorizedDragEnd}>
          <Droppable droppableId="files">
            {(provided) => (
              <div
                className="document-container"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {filteredData.uncategorizedFiles.map((item, i) => (
                  item && (
                    <Row
                      key={item.id || i}
                      item={item}
                      id={item.id}
                      index={i}
                      draggable={draggable}
                      type="files"
                      onShowAddFilePopup={handleShowFilePopup} 
                      showIntegrationColumn={showIntegrationColumn} 
                      catmoParentId={catmoParentId || catmoNodeId} 
                      isCatmoDescendant={item.hasCatmoLineage || false}
                    />
                  )
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}

      {filteredData?.categories?.length > 0 && (
        <DragDropContext onDragEnd={() => {}}>
          <Droppable droppableId="categories">
            {(provided) => (
              <div
                className="document-container"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {filteredData.categories.map((item, i) => (
                  item && (
                    <Row
                      key={item.id || i}
                      item={item}
                      id={item.id}
                      index={i}
                      draggable={draggable}
                      type="categories"
                      onShowAddFilePopup={handleShowFilePopup}
                      onShowAddSubcategoryPopup={handleShowAddSubcategoryPopup}
                      showIntegrationColumn={showIntegrationColumn}
                      catmoParentId={catmoParentId || catmoNodeId} 
                      isCatmoDescendant={false}
                      isCategoryExpanded={isCategoryExpanded}
                      toggleCategoryExpansion={toggleCategoryExpansion}
                    />
                  )
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </>
  ) : (
    <div className="no-data">No Data Available</div>
  )}

      {(showAddCategoryPopup || showAddSubcategoryPopup || showLocalFilePopup || (typeof showAddFilePopup === 'boolean' && showAddFilePopup)) && (
        <AddCategory
          mode={showLocalFilePopup ? "FILE" : "CATEGORY"}
          data={showAddSubcategoryPopup ? subcategoryParentData : {}}
          isCategory={!showLocalFilePopup}
          isChild={showAddSubcategoryPopup}
          onCancel={handlePopupClose}
        />
      )}
    </div>
  );
};

CategoryTable.propTypes = {
  currentItems: PropTypes.shape({
    categories: PropTypes.array,
    uncategorizedFiles: PropTypes.array
  }),
  draggable: PropTypes.bool,
  showAddFilePopup: PropTypes.func,
  showAddCategoryPopup: PropTypes.func,
  isCategory: PropTypes.bool,
  parentHandlePopupClose: PropTypes.func
  
};

export default CategoryTable;